export default class SiteMapService {

    constructor(resource) {
        this.sitemap = resource('generate-sitemap');
    }

    sendMap(obj) {
        return this.sitemap
            .save(obj)
            .then( res =>  {
            }, err => {
                throw new Error('Não foi possível obter a lista de termos.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/siteMapService.js